module.exports = __webpack_public_path__ + "img/sqzs2025.0d54909a.png";